import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
@Injectable({
  providedIn: 'root'
})
export class WorkflowsService {

  constructor(
    private _utils: UtilsService
  ) { } 
  /**
     * getWorkflowDataByType: Method to get the data related to the workflow 
     * @param  {number}     : Possible Value: 
     *                        1: Events
     *                        2: Actions
     *                        3: Rules set(Conditions)
     */
  getWorkflowDataByType(type: any) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.workFlowRules);
    return this._utils.getAPICall(url, this._utils.setHeaderWithParams({
      "type": type,
      "brand_id": Helpers.brandDetails ? Helpers.brandDetails._id : null
    }))
  }

  updateWorkflow(params) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.workFlowRule);
    return this._utils.putAPICall(url, {
      brand_id: params["brandId"],
      uuid: params["workflow"]["uuid"]
    }, this._utils.setHeaders())
  }

  insertWorkflow(params) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.workFlowRule);
    return this._utils.postAPICall(url, params, this._utils.setHeaders());
  }

  deleteWorkflow(params) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.workFlowRule);
    return this._utils.deleteAPICall(url, {
      brand_id: params["brandId"],
      uuid: params["uuid"]
    }, this._utils.setHeaders());
  }

  getWorkflowList(brandId) {         //it get manager and rules detail both together 
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.workFlowList);
    return this._utils.getAPICall(url, this._utils.setHeaderWithParams({
      "brand_id": brandId
    }))
  }
}
